import {
  Button,
  Card,
  Group,
  IconWarningAlt,
  Modal,
  OptionInterface,
  Select,
  SelectOption,
  Table,
  TablePagination,
  TablePreferences,
  Tabs,
} from "@veneer/core";

import "../../assets/css/views/brands/brands.css";

import { useTranslation } from "react-i18next";
import { useState } from "react";
import { UseBrandsPointOfSale } from "../../hooks/brands/useBrands";
import {
  IOptionsBrands,
  IValidationBrands,
} from "../../models/dto/surveyApi/IBrandsDto";
import { ConfirmModal } from "../../components/Modals/ConfirmModal";
import { ModalMessageLoading } from "../SellOut/SellOutComponent/ModalMessageLoading";

export default function BrandsNew() {
  const [t] = useTranslation("global");
  const [selectedTabIdDefault, setSelectedTabIdDefault] = useState(0);

  const initialValidation: IValidationBrands = {
    Country: true,
    SubRetail: true,
    PointOfSale: true,
  };

  const initialOptions: IOptionsBrands = {
    Country: [],
    SubRetail: [],
    PointOfSale: [],
  };

  const [optionSelect, setOptionSelect] =
    useState<IOptionsBrands>(initialOptions);

  const [handleValidate, setHandleValidate] = useState({
    ...initialValidation,
  });

  const {
    tableData,
    columns,
    columnsWidth,
    pagedData,
    currentPage,
    pageSize,
    loading,
    setCurrentPage,
    setPageSize,
    onChangeSelect,
    onClickOpenButtonAddBrand,
    brands,
    onChangeBrand,
    categories,
    onChangeCategory,
    subCategories,
    selectedBrand,
    selectedCategory,
    selectedSubCategory,
    onChangeSubCategory,
    disabledSubCategories,
    setSelectedBrand,
    setSelectedCategory,
    setSelectedSubCategory,
    messageError,
    onClearModal,
    onClose,
    openModalCreate,
    disabledButtonSend,
    submitNewBrand,
    modalMode,
    modalMessage,
    selectedCountry,
    selectedSubRetail,
    selectedPointOfSale,
    closeModal,
    selectCountry,
    selectSubRetail,
    selectPost,
    onClearSelect,
    originalData,
    isLoadingBrands,
    setIsLoadingBrands,
    handleSearch,
    optionsCountryCopy,
    optionsSubRetailCopy,
    optionsPointOfSaleCopy,
  } = UseBrandsPointOfSale(setOptionSelect, setHandleValidate);

  const handlePageChange = (page: number) => setCurrentPage(page);

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLElement>,
    option: OptionInterface<number>
  ) => setPageSize(option.value);

  const paginationProps: TablePagination = {
    currentPage,
    onPageChange: handlePageChange,
    onPageSizeChange: handlePageSizeChange,
    pageSize,
    totalItems: tableData.length,
  };

  const tablePreferences: TablePreferences = {
    width: columnsWidth,
  };

  const getPosLabel = (): string => {
    if (
      selectCountry.current &&
      !selectSubRetail.current &&
      !selectPost.current
    ) {
      return t("header.country");
    }

    if (
      selectCountry.current &&
      selectSubRetail.current &&
      !selectPost.current
    ) {
      return t("header.subRetail");
    }

    if (
      selectCountry.current &&
      selectSubRetail.current &&
      selectPost.current
    ) {
      return t("header.pos");
    }

    return t("header.country");
  };

  return (
    <div className="brands-page">
      <div>
        <h4>{t("header.brands")}</h4>
      </div>
      <Tabs
        controlId="brandsNew"
        mode="extended"
        onChangeTab={setSelectedTabIdDefault}
        selectedTabId={selectedTabIdDefault}
        tabs={[
          {
            id: 0,
            label: getPosLabel(),
            content: (
              <>
                <div className="brands-filters">
                  <div className="brands-filters_selects">
                    <Select
                      clearIcon={true}
                      onClear={() => onClearSelect("Country")}
                      options={optionSelect.Country}
                      id="selectCountry"
                      label={t("header.country")}
                      placement="bottom"
                      helperTextVisibility="auto"
                      onChange={(e: SelectOption) =>
                        onChangeSelect(Number(e.value), "Country")
                      }
                      value={selectedCountry ? [selectedCountry] : []}
                      onSearch={(query: string) =>
                        handleSearch(
                          query,
                          optionsCountryCopy.current,
                          "Country"
                        )
                      }
                      searchDelay={500}
                      showSearch={true}
                    />

                    <Select
                      clearIcon={true}
                      onClear={() => onClearSelect("SubRetail")}
                      options={optionSelect.SubRetail}
                      id="selectSubRetail"
                      label={t("header.subRetail")}
                      placement="bottom"
                      helperTextVisibility="auto"
                      onChange={(e: SelectOption) =>
                        onChangeSelect(Number(e.value), "SubRetail")
                      }
                      value={selectedSubRetail ? [selectedSubRetail] : []}
                      disabled={handleValidate.Country}
                      onSearch={(query: string) =>
                        handleSearch(
                          query,
                          optionsSubRetailCopy.current,
                          "SubRetail"
                        )
                      }
                      searchDelay={500}
                      showSearch={true}
                    />

                    <Select
                      clearIcon={true}
                      onClear={() => onClearSelect("PointOfSale")}
                      options={optionSelect.PointOfSale}
                      id="selectPointOfSale"
                      label={t("header.pos")}
                      placement="bottom"
                      helperTextVisibility="auto"
                      onChange={(e: SelectOption) =>
                        onChangeSelect(e.value, "PointOfSale")
                      }
                      value={selectedPointOfSale ? [selectedPointOfSale] : []}
                      disabled={handleValidate.SubRetail}
                      onSearch={(query: string) =>
                        handleSearch(
                          query,
                          optionsPointOfSaleCopy.current,
                          "PointOfSale"
                        )
                      }
                      searchDelay={500}
                      showSearch={true}
                    />
                  </div>

                  <Button
                    onClick={() => onClickOpenButtonAddBrand()}
                    disabled={handleValidate.Country}
                  >
                    {t("header.addBrand")}
                  </Button>
                </div>
                {originalData && originalData.length > 0 && (
                  <Card
                    appearance="outlined"
                    className="brands-table"
                    content={
                      <>
                        <Table
                          showFilters={true}
                          preferences={tablePreferences}
                          className="brands-table_grid"
                          columnResize
                          loading={loading}
                          columns={columns}
                          data={pagedData}
                          loadingDataLength={10}
                          pagination={paginationProps}
                          behavior={{
                            type: "singlePage",
                          }}
                          customNoItems={
                            <div className="customNoItems">
                              <div className="DivIconCustomNoItems">
                                <IconWarningAlt className="IconCustomNoItems" />
                              </div>
                              {t("header.noItemsFound")}
                            </div>
                          }
                        />
                      </>
                    }
                  />
                )}
              </>
            ),
          },
        ]}
        type="attached"
      />
      <div style={{ position: "relative" }}>
        <Modal
          align="center"
          id="addBrands"
          show={openModalCreate}
          onClose={() => onClose()}
          title={t("brands.addBrands")}
          footer={
            <div className="brands-modal_footer">
              <Group>
                <Button appearance="secondary" onClick={() => onClose()}>
                  Cerrar
                </Button>
                <Button
                  disabled={disabledButtonSend}
                  onClick={() => submitNewBrand()}
                >
                  {modalMode === "create"
                    ? t("header.sendButton")
                    : t("header.update")}
                </Button>
              </Group>
            </div>
          }
        >
          <div className="brands-modal">
            <Select
              className="brands-modal_field"
              options={brands}
              id="select-brands"
              label={t("header.brands")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeBrand}
              onClear={() => onClearModal(setSelectedBrand, "brands")}
              value={selectedBrand}
              disabled={modalMode === "update"}
            />
            <Select
              className="brands-modal_field"
              options={categories}
              id="select-categories"
              label={t("header.categories")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeCategory}
              onClear={() => onClearModal(setSelectedCategory, "categories")}
              value={selectedCategory}
              multiple={true}
            />
            <Select
              className="brands-modal_field"
              options={subCategories}
              id="select-subCategories"
              label={t("brands.subcategories")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeSubCategory}
              onClear={() =>
                onClearModal(setSelectedSubCategory, "subCategories")
              }
              value={selectedSubCategory}
              multiple={true}
              disabled={disabledSubCategories}
            />
            {messageError && <p>{messageError}</p>}
          </div>
        </Modal>
      </div>

      <ConfirmModal
        open={modalMessage.show}
        title={modalMessage.title}
        description={modalMessage.description}
        primaryLabel={modalMessage.primaryLabel}
        secondaryLabel={modalMessage.secondaryLabel}
        onPrimary={modalMessage.onPrimary}
        onSecondary={modalMessage.onSecondary}
        onClose={closeModal}
      />

      <ModalMessageLoading
        id="modal-processingfile"
        setOpenCloseModal={() => setIsLoadingBrands(false)}
        openModal={isLoadingBrands}
        titleMessage={t("brands.validatingBrands")}
        message={t("brands.fewSeconds")}
      />
    </div>
  );
}
